import countries from '../constants/countries'
import { isIE, } from './ie'

const getCountryByCode = (code) => countries.find((c) => c.code === code)

export const getCountryFlagByCode = (code) => {
  return code ? `/static/countries/${code.toLowerCase()}.svg` : ''
}

export const getCountryNameByCode = (code) => {
  const country = getCountryByCode(code)
  return country ? country.name : ''
}



// WEBPACK FOOTER //
// ./src/utils/countries.js